import React from 'react';
import { Button } from '../ui/Button';
export function Hero() {
  const productImg = 'https://cdn.magicpatterns.com/uploads/sqWj2RGF8QLq23vTiDj7BE/heylloyd-image-1771222482108.png';
  return <section className="relative overflow-hidden bg-gradient-to-b from-amber-50 to-white pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-87">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-89">
          {/* Content */}
          <div className="w-full lg:w-1/2 text-center lg:text-left z-10" data-id="element-90">
            <span className="inline-block py-1 px-3 rounded-full bg-amber-100 text-amber-800 text-sm font-semibold tracking-wide uppercase mb-6" data-id="element-91">
              For Women Over 45
            </span>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-stone-900 leading-tight mb-6" data-id="element-92">
              If You’re Over 45 and Your Belly Feels Like an{' '}
              <span className="text-amber-600" data-id="element-93">“Inflated Balloon”</span> Every
              Afternoon…
            </h1>

            <h2 className="text-xl sm:text-2xl text-stone-600 font-medium mb-8 leading-relaxed" data-id="element-94">
              It’s Not Your Age. It’s Your Hormones.
            </h2>

            <p className="text-lg text-stone-600 mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-95">
              Stop the cardio. Stop the starvation diets. Discover the 5-minute
              "Ancient Code" that flushes out menopause bloat and firms your
              skin—starting tomorrow morning.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-96">
              <Button size="xl" showIcon={true} onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-97">
                YES! GIVE ME INSTANT ACCESS
              </Button>
            </div>
            <p className="mt-4 text-sm text-stone-500 italic" data-id="element-98">
              *Instant Digital Download – PDF Format
            </p>
          </div>

          {/* Image */}
          <div className="w-full lg:w-1/2 relative" data-id="element-99">
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-amber-200/20 rounded-full blur-3xl -z-10" data-id="element-100"></div>
            <img src={productImg} alt="The Golden Root Ritual Book Cover" className="w-full max-w-md mx-auto lg:max-w-full rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-101" />
          </div>
        </div>
      </div>
    </section>;
}